import { Construction } from 'lucide-react'
import { EmptyState } from '@/components/feedback/EmptyState'
import { PageHeader } from '../layout/PageHeader'

/** Placeholder neutro para itens de menu cuja feature ainda não foi registrada. */
export function UnderConstructionPage() {
  return (
    <div className="space-y-5">
      <PageHeader />
      <EmptyState
        icon={Construction}
        title="Em construção"
        description="Esta área faz parte do Woctools v2 e ainda está sendo construída. Ela aparecerá aqui assim que for publicada."
        className="py-16"
      />
    </div>
  )
}
